import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col } from 'tea-component';
import { useIntl } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';

import BubbleCommon, {
  overviewEmergingTips,
  overviewKeywordTips,
  overviewNegativeTips,
  overviewPositiveTips,
} from '@/pages/opinion/components/BubbleCommon';
import TopicCard from './TopicCard';
import KeywordCard from './KeywordCard';
import { buriedBtnPoint } from '@/pages/opinion/operationLog/buriedPoint';
import { arrayToSimpleObj } from '@/pages/opinion/utils';
import { v4 as uuidv4 } from 'uuid';

const filters = [
  { text: 'Total-2', value: 'total' },
  { text: 'Negative', value: 'negative', tipsMap: overviewNegativeTips },
  { text: 'Positive', value: 'positive', tipsMap: overviewPositiveTips },
  {
    text: 'Emerging',
    value: 'emerging',
    tipsMap: overviewEmergingTips,
  },
];
const tabObjMap = arrayToSimpleObj(filters);

export default function TopicKeyword({ filter, translateTopic }: any) {
  const { formatMessage } = useIntl(); 
  const [curFilter, setCurFilter] = useState('total');
  const [clickInfo, setClickInfo] = useState({
    dataIndex: null,
    seriesIndex: null,
    seriesName: null,
    name: null,
    except_others: null,
    except_topic: null,
    translationData: null,
  });

  const uniqueId = useMemo(() => uuidv4(), [filter, curFilter]);

  const handleClickInfo = (params: any) => {
    setClickInfo(params);
  };

  const [keywordTipsVisible, setKeywordTipsVisible] = useState<boolean>(false);

  let localHasShowKeywordTips = false;

  try {
    localHasShowKeywordTips = Boolean(
      window.localStorage.getItem('topic-keyword-has-show-keyword'),
    );
  } catch {}

  const [hasShowKeywordTips, setHasShowKeywordTips] = useState(
    localHasShowKeywordTips,
  );

  useEffect(() => {
    if (filter?.language?.length > 0 && !hasShowKeywordTips) {
      setKeywordTipsVisible(true);
    }
  }, [filter]);

  const keywordFilter = useMemo(() => {
    return { ...filter, exclude_hashtag: true };
  }, [filter]);

  return (
    <Row className="dbo-cardrow-wrap dbo-performance-topic">
      <Col>
        <CardCommon
          title={formatMessage({ id: 'Topic & Keyword' })}
          filters={filters.map((item) => ({
            ...item,
            text: (
              <BubbleCommon showIcon={false} tipsMap={item.tipsMap}>
                {formatMessage({ id: item.text })}
              </BubbleCommon>
            ),
          }))}
          handleFilterOnChange={(value) => {
            setCurFilter(value);
            setClickInfo({
              dataIndex: null,
              seriesIndex: null,
              seriesName: null,
              name: null,
              except_others: null,
              except_topic: null,
              translationData: null,
            });
            buriedBtnPoint('TK_sentimentTab', tabObjMap[value]);
          }}
        >
          <Row
            style={{ marginTop: 2 }}
            className="performance-topic-keyword-card"
          >
            <Col span={12} className="dbo-performance-topic-card">
              <TopicCard
                filter={filter}
                curFilter={curFilter}
                translateTopic={translateTopic}
                handleClickInfo={handleClickInfo}
              ></TopicCard>
            </Col>

            <Col span={12} className="dbo-performance-keyword-card">
              <KeywordCard
                key={uniqueId}
                filter={keywordFilter}
                curFilter={curFilter}
                clickInfo={clickInfo}
                hasKeywordDownPage={true}
                dealwithTimeLineParams={(params: any) => ({
                  ...params,
                  statistics_field: 'overview',
                })}
                title={
                  <>
                    <BubbleCommon
                      escapeWithReference
                      showIcon={false}
                      hasCloseIcon
                      tipsMap={overviewKeywordTips}
                      placement="top"
                      visible={keywordTipsVisible}
                      handleCloseIconClick={(e: Event) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setKeywordTipsVisible(false);
                        setHasShowKeywordTips(true);
                        window.localStorage.setItem(
                          'topic-keyword-has-show-keyword',
                          'true',
                        );
                        return false;
                      }}
                    >
                      {formatMessage({ id: 'Keyword' })}
                      <BubbleCommon
                        showIcon={true}
                        tipsMap={
                          keywordTipsVisible ? null : overviewKeywordTips
                        }
                        placement="top"
                      ></BubbleCommon>
                    </BubbleCommon>
                  </>
                }
              ></KeywordCard>
            </Col>
          </Row>
        </CardCommon>
      </Col>
    </Row>
  );
}
